import { injectable } from 'inversify';
import { Component } from '../../../concepts/objects';
import { LensAspect } from '../lens/LensAspect';
import { LensAspectProvider } from '../lens/LensAspectProvider';
import { JiraCard } from './JiraCard';

const staticAspects = [
    LensAspect.create(
        'string',
        'JiraCard.issueType',
        'issueType',
        'The Jira issue type.',
        'property',
        (elmt: Component) => {
            return elmt.as(JiraCard)?.record?.issueType?.name;
        }
    ),
    LensAspect.create(
        'string',
        'JiraCard.priority',
        'priority',
        'The Jira issue priority.',
        'property',
        (elmt: Component) => {
            return elmt.as(JiraCard)?.record?.priority?.name;
        }
    ),
    LensAspect.create(
        'string',
        'JiraCard.status',
        'status',
        'The Jira issue status.',
        'property',
        (elmt: Component) => {
            return elmt.as(JiraCard)?.record?.status?.name;
        }
    ),
    LensAspect.create(
        'string',
        'JiraCard.assignee',
        'assignee',
        'The Jira assignee.',
        'property',
        (elmt: Component) => {
            return elmt.as(JiraCard)?.record?.assignee?.displayName;
        }
    ),
    LensAspect.create(
        'string',
        'JiraCard.summary',
        'summary',
        'The Jira issue summary.',
        'property',
        (elmt: Component) => {
            return elmt.as(JiraCard)?.record?.summary;
        }
    ),
];

const customFieldAspects = (elmts: Component[]) => {
    const map = new Map<string, LensAspect>();

    for (const e of elmts) {
        const card = e.as(JiraCard);
        if (!card) continue;

        for (const ci of card.customs) {
            if (map.has(ci.key)) continue;
            map.set(ci.key,
                LensAspect.create(
                    ci.type === 'number' ? 'number' : 'string',
                    `JiraCard.Customs.${ci.key}`,
                    ci.key,
                    ci.name,
                    'property',
                    (elmt: Component) => {
                        return elmt.as(JiraCard)?.record?.custom?.[ci.key]?.value;
                    }
                )
            );
        }
    }

    return Array.from(map.values());
};

@injectable()
export class JiraCardLensAspectProvider implements LensAspectProvider {

    public getAspectsFor(elmts: Component[]): LensAspect[] {
        if (!elmts.some(x => x.is(JiraCard))) return [];
        return staticAspects.concat(customFieldAspects(elmts));
    }
}
